export default __webpack_public_path__ + "static/media/WP Developer Icon With Text 1.978cd473.svg";